module.exports = __webpack_public_path__ + "img/svg/avatar.260b3bb470766c301ef444babf829f8d.svg";